import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
import { FiChevronUp, FiChevronDown, FiEdit3 } from "react-icons/fi";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { makeSelectStyles } from "../../common/selectStyles";
function EditCgp() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isIdentificationAccordionOpen, setIsIdentificationAccordionOpen] =
    useState(true);

  const toggleIdentificationAccordion = () => {
    setIsIdentificationAccordionOpen(!isIdentificationAccordionOpen);
  };
  // État pour le collapse
  const [
    isDonneesComplementAccordionOpen,
    setIsDonneesComplementAccordionOpen,
  ] = useState(true);

  // Fonction toggle
  const toggleDonneesComplementAccordion = () => {
    setIsDonneesComplementAccordionOpen(!isDonneesComplementAccordionOpen);
  };
  // État pour le collapse
  const [isDonneesDirectionAccordionOpen, setIsDonneesDirectionAccordionOpen] =
    useState(true);

  // Fonction toggle
  const toggleDonneesDirectionAccordion = () => {
    setIsDonneesDirectionAccordionOpen(!isDonneesDirectionAccordionOpen);
  };

  const styles = makeSelectStyles(layout);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [cgpData, setCgpData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  /*************************   Type Partenaire *******************************/
  const [typePartenaireData, setTypePartenaireData] = useState({ data: [] });
  const [selectedType, setSelectedType] = useState("");
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const getType = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/mes_cgps/types_partenaires`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((type) => {
          setTypePartenaireData(type);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeOptions = () => {
    return [
      {
        options: typePartenaireData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Personne physique *******************************/
  const [pPData, setPpData] = useState({ data: [] });
  const [selectedPersonnePhysique, setSelectedPp] = useState("");
  const handlePersonneChange = (e) => {
    setSelectedPp(e);
  };
  const getPP = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/mes_cgps/contacts`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pp) => {
          setPpData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPpOptions = () => {
    return [
      {
        options: pPData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Personne Morale *******************************/
  const [pMData, setPmData] = useState({ data: [] });
  const [selectedPm, setSelectedPm] = useState("");
  const handlePmChange = (e) => {
    setSelectedPp(e);
  };
  const getPM = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/mes_cgps/partenaires?id=${id}&types_partenaire_id=${selectedType?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pp) => {
          setPmData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmOptions = () => {
    return [
      {
        options: pMData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Type Personne *******************************/
  const [TypePersonneData, setTypePersonneData] = useState({ data: [] });
  const [selectedTypePersonne, setSelectedTypePersonne] = useState("");
  const handleTypePersonneChange = (e) => {
    setSelectedTypePersonne(e);
  };
  const getTypePersonne = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/mes_cgps/type_personnes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pp) => {
          setTypePersonneData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypePersonneOptions = () => {
    return [
      {
        options: TypePersonneData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Tête de réseau *******************************/
  const [teteReseauData, setTeteReseauData] = useState({ data: [] });
  const [selectedTeteReseau, setSelectedTeteReseau] = useState("");
  const handleTeteReseauChange = (e) => {
    setSelectedTeteReseau(e);
  };
  console.log(selectedTeteReseau);
  const getTeteReseau = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/mes_cgps/societes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setTeteReseauData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTeteReseauOptions = () => {
    return [
      {
        options: teteReseauData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Taux d'apport  *******************************/
  const [tauxData, setTauxData] = useState({ data: [] });
  const [selectedTaux, setSelectedTaux] = useState("");
  const handleTauxChange = (e) => {
    setSelectedTaux(e);
  };
  const getTaux = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/mes_cgps/taux_apports`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setTauxData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxOptions = () => {
    return [
      {
        options: tauxData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Modèle dossier de souscription & TEPA  *******************************/
  const [modeleData, setModeleData] = useState({ data: [] });
  const [selectedModele, setSelectedModele] = useState("");
  const handleModeleChange = (e) => {
    setSelectedModele(e);
  };
  const [selectedModeleT, setSelectedModeleT] = useState("");
  const handleModeleTChange = (e) => {
    setSelectedModeleT(e);
  };
  const getModele = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/mes_cgps/publipostages
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setModeleData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModeleOptions = () => {
    return [
      {
        options: modeleData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /************************************* Numero RCS *********************************/
  const [selectedNumero, setSelectedNumero] = useState("");
  const handleNumeroChange = (e) => {
    setSelectedNumero(e.target.value);
  };
  /************************************* Code RCS *********************************/
  const [selectedCode, setSelectedCode] = useState("");
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  /************************************* Actif *********************************/
  const [selectedActif, setSelectedActif] = useState("");
  const handleActifChange = (e) => {
    setSelectedActif(e);
  };
  /************************************* Défaut *********************************/
  const [selectedDefaut, setSelectedDefaut] = useState("");
  const handleDefautChange = (e) => {
    setSelectedDefaut(e);
  };
  /************************************* Trigramme *********************************/
  const [selectedTrigramme, setSelectedTrigramme] = useState("");
  const handleTrigrammeChange = (e) => {
    setSelectedTrigramme(e.target.value);
  };
  /************************************* Origine *********************************/
  const [selectedOrigine, setSelectedOrigine] = useState("");
  const handleOrigineChange = (e) => {
    setSelectedOrigine(e.target.value);
  };
  /************************************* Compte de créance *********************************/
  const [selectedCompteCreance, setSelectedCompteCreance] = useState("");
  const handleCompteCreanceChange = (e) => {
    setSelectedCompteCreance(e.target.value);
  };
  /************************************* Entrepreteurs *********************************/
  const [selectedEntrepreteur, setSelectedEntrepreteur] = useState("");
  const handleEntrepreteurChange = (e) => {
    setSelectedEntrepreteur(e);
  };
  /************************************* Date création activité *********************************/
  const [selectedDateCreation, setSelectedDateCreation] = useState("");
  const handleDateCreationChange = (e) => {
    setSelectedDateCreation(e.target.value);
  };
  /************************************* Surface totale détenue  *********************************/
  const [selectedSurfaceTotal, setSelectedSurfaceTotal] = useState("");
  const handleSurfaceTotalChange = (e) => {
    setSelectedSurfaceTotal(e.target.value);
  };
  /************************************* Surface exploitée   *********************************/
  const [selectedSurfaceExploit, setSelectedSurfaceExploit] = useState("");
  const handleSurfaceExploitChange = (e) => {
    setSelectedSurfaceExploit(e.target.value);
  };

  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };
  const handleSubmitPm = async (event) => {
    event.preventDefault();
    if (selectedPm === null) {
      toast.error("Personne morale ne peut pas être vide");
    } else if (selectedType === null) {
      toast.error("Type ne peut pas être vide");
    } else if (selectedTypePersonne === null) {
      toast.error("Type personne ne peut pas être vide");
    } else {
      try {
        const response = await fetch(`https://www.fluxod.com/${api}/mes_cgps`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            partenaire: {
              type_personne_id: selectedTypePersonne?.value,

              societe_id: selectedPm?.value,
              defaut: selectedDefaut?.value,
              types_partenaire_id: selectedType?.value,
              rcs: selectedNumero,
              code_ape: selectedCode,
              actif: selectedActif?.value,
              trigramme: selectedTrigramme,
              partenaire_id: selectedTeteReseau?.value,
              ///
              origine: selectedOrigine,
              taux_apport_id: selectedTaux.map((item) => item.value),
              publipostage_id: selectedModele?.value,
              publipostage2_id: selectedModeleT?.value,
              entrepreteurs: selectedEntrepreteur?.value,
              ///
              compte_de_creance: selectedCompteCreance,
            },
          }),
        });

        if (response.ok) {
          console.log("POST request successful");

          handleNavigate({ key: true });
        } else {
          console.error("POST request failed");
          const responseData = await response.json();
          if (
            (responseData && responseData.societe_validation) ||
            (responseData && responseData.investisseur_validation)
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors =
              responseData.societe_validation[0] ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const handleSubmitP = async (event) => {
    event.preventDefault();
    if (selectedPm === null) {
      toast.error("Personne morale ne peut pas être vide");
    } else if (selectedType === null) {
      toast.error("Type ne peut pas être vide");
    } else if (selectedTypePersonne === null) {
      toast.error("Type personne ne peut pas être vide");
    } else {
      try {
        const response = await fetch(`https://www.fluxod.com/${api}/mes_cgps`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            partenaire: {
              type_personne_id: selectedTypePersonne?.value,

              contact_id: selectedPersonnePhysique?.value,
              defaut: selectedDefaut?.value,
              types_partenaire_id: selectedType?.value,
              rcs: selectedNumero,
              code_ape: selectedCode,
              actif: selectedActif?.value,
              trigramme: selectedTrigramme,
              partenaire_id: selectedTeteReseau?.value,
              ///
              origine: selectedOrigine,
              taux_apport_id: selectedTaux?.map((item) => item.value) || "",
              publipostage_id: selectedModele?.value,
              publipostage2_id: selectedModeleT?.value,
              entrepreteurs: selectedEntrepreteur?.value,
              ///
              compte_de_creance: selectedCompteCreance,
            },
          }),
        });

        if (response.ok) {
          console.log("POST request successful");

          handleNavigate({ key: true });
        } else {
          console.error("POST request failed");
          const responseData = await response.json();
          if (
            (responseData && responseData.societe_validation) ||
            (responseData && responseData.investisseur_validation)
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors =
              responseData.societe_validation[0] ||
              responseData?.investisseur_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };

  /******************************* END Validation *******************************************/
  useEffect(() => {
    if (!loading) {
      getType();
      getPP();
      getTypePersonne();
      getPM();
      getTeteReseau();
      getTaux();
      getModele();
    }
  }, [loading]);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Mes CGPS | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails CGP
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/mes_cgps/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Mes CGP
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          "Nouveau"
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={
                            selectedTypePersonne?.label == "PP"
                              ? handleSubmitP
                              : handleSubmitPm
                          }
                        >
                          <i className="bx bx-send"></i> Créer
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to={`${backUrl}/mes_cgps/`}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En‑tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleIdentificationAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Identification
                                      </span>
                                    </div>
                                    {isIdentificationAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isIdentificationAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Type personne* */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Type personne
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={selectedTypePersonne}
                                                onChange={
                                                  handleTypePersonneChange
                                                }
                                                options={renderTypePersonneOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(
                                                  selectedTypePersonne === null
                                                )}
                                                menuPortalTarget={document.body}
                                              />
                                              {selectedTypePersonne ===
                                                null && (
                                                <div className="invalid-feedback d-block mt-1 small">
                                                  Type personne ne peut pas être
                                                  vide
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Personne Physique* */}
                                        {selectedTypePersonne?.label ===
                                          "PP" && (
                                          <div
                                            className="field-item px-2 py-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: "3px solid #dc3545",
                                              marginBottom: "1px",
                                              position: "relative",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#ffe6e6";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Personne Physique
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <Select
                                                  value={
                                                    selectedPersonnePhysique
                                                  }
                                                  onChange={
                                                    handlePersonneChange
                                                  }
                                                  options={renderPpOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedPersonnePhysique ===
                                                      null
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                />
                                                {selectedPersonnePhysique ===
                                                  null && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Personne physique ne peut
                                                    pas être vide
                                                  </div>
                                                )}
                                              </Col>
                                            </Row>
                                          </div>
                                        )}

                                        {/* Personne Morale */}
                                        {selectedTypePersonne?.label ===
                                          "PM" && (
                                          <div
                                            className="field-item px-2 py-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: "3px solid #dc3545",
                                              marginBottom: "1px",
                                              position: "relative",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#ffe6e6";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Personne Morale
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <Select
                                                  value={selectedPm}
                                                  onChange={handlePmChange}
                                                  options={renderPmOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(false)}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        )}

                                        {/* Type* */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Type
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={selectedType}
                                                onChange={handleTypeChange}
                                                options={renderTypeOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(
                                                  selectedType === null
                                                )}
                                                menuPortalTarget={document.body}
                                              />
                                              {selectedType === null && (
                                                <div className="invalid-feedback d-block mt-1 small">
                                                  Type ne peut pas être vide
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* N° RCS */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  N° RCS
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <input
                                                className="form-control form-control-sm shadow-sm border-0"
                                                value={selectedNumero}
                                                required
                                                onChange={handleNumeroChange}
                                                style={{
                                                  fontSize: "0.8rem",
                                                  backgroundColor: "#f8f9fa",
                                                  borderRadius: "6px",
                                                  padding: "0.375rem 0.75rem",
                                                  height: "32px",
                                                }}
                                              />
                                              <FiEdit3
                                                size={12}
                                                className="position-absolute text-muted"
                                                style={{
                                                  right: "8px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                  pointerEvents: "none",
                                                  opacity: 0.9,
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Code APE */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Code APE
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <input
                                                className="form-control form-control-sm shadow-sm border-0"
                                                value={selectedCode}
                                                required
                                                onChange={handleCodeChange}
                                                style={{
                                                  fontSize: "0.8rem",
                                                  backgroundColor: "#f8f9fa",
                                                  borderRadius: "6px",
                                                  padding: "0.375rem 0.75rem",
                                                  height: "32px",
                                                }}
                                              />
                                              <FiEdit3
                                                size={12}
                                                className="position-absolute text-muted"
                                                style={{
                                                  right: "8px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                  pointerEvents: "none",
                                                  opacity: 0.9,
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Actif* */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Actif
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={selectedActif}
                                                onChange={handleActifChange}
                                                options={renderOuiNonOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(
                                                  selectedActif === null
                                                )}
                                                menuPortalTarget={document.body}
                                              />
                                              {selectedActif === null && (
                                                <div className="invalid-feedback d-block mt-1 small">
                                                  Actif ne peut pas être vide
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Défaut */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Défaut
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={selectedDefaut}
                                                onChange={handleDefautChange}
                                                options={renderOuiNonOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(false)}
                                                menuPortalTarget={document.body}
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Trigramme */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Trigramme
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <input
                                                className="form-control form-control-sm shadow-sm border-0"
                                                value={selectedTrigramme}
                                                required
                                                onChange={handleTrigrammeChange}
                                                style={{
                                                  fontSize: "0.8rem",
                                                  backgroundColor: "#f8f9fa",
                                                  borderRadius: "6px",
                                                  padding: "0.375rem 0.75rem",
                                                  height: "32px",
                                                }}
                                              />
                                              <FiEdit3
                                                size={12}
                                                className="position-absolute text-muted"
                                                style={{
                                                  right: "8px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                  pointerEvents: "none",
                                                  opacity: 0.9,
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Tête de réseau* */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Tête de réseau
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={selectedTeteReseau}
                                                onChange={
                                                  handleTeteReseauChange
                                                }
                                                options={renderTeteReseauOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(
                                                  selectedTeteReseau === null
                                                )}
                                                menuPortalTarget={document.body}
                                              />
                                              {selectedTeteReseau === null && (
                                                <div className="invalid-feedback d-block mt-1 small">
                                                  Tête de réseau ne peut pas
                                                  être vide
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>

                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleDonneesComplementAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Données complémentaires CGP
                                      </span>
                                    </div>
                                    {isDonneesComplementAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isDonneesComplementAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Origine */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Origine
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <input
                                                className="form-control form-control-sm shadow-sm border-0"
                                                value={selectedOrigine}
                                                required
                                                onChange={handleOrigineChange}
                                                style={{
                                                  fontSize: "0.8rem",
                                                  backgroundColor: "#f8f9fa",
                                                  borderRadius: "6px",
                                                  padding: "0.375rem 0.75rem",
                                                  height: "32px",
                                                }}
                                              />
                                              <FiEdit3
                                                size={12}
                                                className="position-absolute text-muted"
                                                style={{
                                                  right: "8px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                  pointerEvents: "none",
                                                  opacity: 0.9,
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Taux d'apport (restriction) */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Taux d&apos;apport
                                                  (restriction)
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={selectedTaux}
                                                onChange={handleTauxChange}
                                                options={renderTauxOptions()}
                                                isClearable={true}
                                                isMulti={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(false)}
                                                menuPortalTarget={document.body}
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Modèle dossier de souscription */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Modèle dossier de souscription
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={selectedModele}
                                                onChange={handleModeleChange}
                                                options={renderModeleOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(false)}
                                                menuPortalTarget={document.body}
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Modèle dossier de souscription TEPA */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Modèle dossier de souscription
                                                  TEPA
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={selectedModeleT}
                                                onChange={handleModeleTChange}
                                                options={renderModeleOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(false)}
                                                menuPortalTarget={document.body}
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Entrepreteurs */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Entrepreteurs
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={selectedEntrepreteur}
                                                onChange={
                                                  handleEntrepreteurChange
                                                }
                                                options={renderOuiNonOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(false)}
                                                menuPortalTarget={document.body}
                                              />
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>

                                <Row>
                                  <Col sm="12">
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En-tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={
                                          toggleDonneesDirectionAccordion
                                        }
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Données complémentaires Direction
                                            produit
                                          </span>
                                        </div>
                                        {isDonneesDirectionAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={isDonneesDirectionAccordionOpen}
                                      >
                                        <CardBody className="p-0">
                                          <div
                                            className="fields-container"
                                            style={{ paddingBottom: "8px" }}
                                          >
                                            {/* Compte de créance */}
                                            <div
                                              className="field-item px-2 py-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                marginBottom: "1px",
                                                position: "relative",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Compte de créance
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={
                                                      selectedCompteCreance
                                                    }
                                                    required
                                                    onChange={
                                                      handleCompteCreanceChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          </div>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditCgp;
